export function gridContext_doCalcVehicleGridPositions(vehicles = [], gridSettings = {}) {
  if (!Array.isArray(vehicles) || !gridSettings || vehicles.length === 0) {
    return 0;
  }

  const {
    kellonajat_height = 0,
    vehicleRowHeight = 0,
    vehicleGap = 0,
    rowHeight = 0,
    barHeight = 0,
    kuskiHeight = 0,
  } = gridSettings;

  // Pre-calculate static values
  const heightOffset = rowHeight - barHeight;
  let nextPosY = kellonajat_height;
  let visibleCounter = 0;

  // Using forEach is more performant for large arrays
  vehicles.forEach((vehicle, i) => {
    // Destructure commonly used properties
    const { showInGridCalc, driverCount = 0, grid_rowCount = 1 } = vehicle;
    vehicle.grid_rowNo ??= i;

    if (!showInGridCalc) {
      vehicle.grid_rowHeight = 0;
      vehicle.grid_posY = nextPosY;
      return;
    }

    // Single calculation for driver height
    const driverHeight = driverCount * kuskiHeight;
    const baseRowHeight = vehicleRowHeight * grid_rowCount + heightOffset + vehicleGap;
    const gridRowHeight = Math.max(baseRowHeight, driverHeight);

    vehicle.grid_rowHeight = gridRowHeight;
    vehicle.grid_posY = nextPosY;

    if (gridRowHeight > 0) {
      nextPosY += gridRowHeight;
      // Bitwise operation is faster than modulo
      vehicle.rowDividableBy2 = !(visibleCounter & 1);
      visibleCounter++;
    }
  });

  return nextPosY;
}

export function gridContext_getMaxRotationDegrees(gridKeikka) {
  // Simplified calculation with combined constants
  return gridKeikka.pumppuKesto ? 250 / gridKeikka.pumppuKesto : 0;
}
